import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames'


export default function TabButton({
    label,
    isSelected,
    shouldFocus,
    onSelect,
    onSelectNext,
    onSelectPrevious,
    onSelectFirst,
    onSelectLast,
    controlsId,
    id,
    isDisabled,
    isHidden
}) {
    const buttonRef = useRef();

    useEffect(() => {
        if (isSelected && shouldFocus) {
            buttonRef.current.focus();
        }
    }, [isSelected, shouldFocus])

    const handleKeyDown = (e) => {
        if (e.key === 'ArrowRight') {
            e.preventDefault();
            onSelectNext();
        }
        else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            onSelectPrevious();
        }
        else if (e.key === 'Home') {
            e.preventDefault();
            onSelectFirst();
        }
        else if (e.key === 'End') {
            e.preventDefault();
            onSelectLast();
        }
    }

    return (
        <button
            data-component="TabButton"
            className={cx({
                hidden: isHidden,
                selected: isSelected
            })}
            disabled={isDisabled || isHidden}
            ref={buttonRef}
            role="tab"
            aria-selected={isSelected}
            tabIndex={isSelected ? null : '-1'}
            id={id}
            aria-controls={controlsId}
            onKeyDown={handleKeyDown}
            onClick={onSelect} >
            <div>
                {label}
            </div>
        </button>
    );
}

TabButton.propTypes = {
    isSelected: PropTypes.bool,
    shouldFocus: PropTypes.bool.isRequired,
    onSelect: PropTypes.func,
    onSelectNext: PropTypes.func.isRequired,
    onSelectPrevious: PropTypes.func.isRequired,
    onSelectFirst: PropTypes.func.isRequired,
    onSelectLast: PropTypes.func.isRequired,
    label: PropTypes.node.isRequired,
    controlsId: PropTypes.string,
    id: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    isHidden: PropTypes.bool
}
